import React, { Fragment } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import NarrowContent from "./NarrowContent";
import ActionsWrapper from "./ActionsWrapper";
import { ApplicationPaths } from "./api-authorization/ApiAuthorizationConstants";
import Footer from "./Footer";
import { SoundtrackCarousel } from "./SoundtrackCarousel";
import { useAuth } from "./api-authorization/AuthContext";

const Home: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const renderStartButton = (): React.ReactNode => {
    return isAuthenticated ? (
      <Button color="primary" tag={Link} to="/events">
        My Events
      </Button>
    ) : (
      <Fragment>
        <Button
          color="primary"
          tag={Link}
          to={ApplicationPaths.IdentityRegisterPath}
        >
          Create your first event
        </Button>
        <Button color="secondary" tag={Link} to="/events">
          Login
        </Button>
      </Fragment>
    );
  };

  return (
    <div>
      <SoundtrackCarousel />
      <NarrowContent className="my-3 text-center">
        <h1>Soundtrack your life</h1>
        <p>
          Soundtrack your next event or gathering with themed, collaborative
          playlists to relive music memories and create new ones.
        </p>
        <ActionsWrapper>{renderStartButton()}</ActionsWrapper>
        <p>
          Mixopia is a not-for-profit passion project, born from our belief in
          the connective power of music.
        </p>
        <p>
          Through Mixopia, it is easy for everyone to contribute to the music at
          events & gatherings: encouraging storytelling, dancing, and singing
          along.
        </p>
        <p>
          We love feedback, so please let us know about your Mixopia experience
          at <a href="mailto:support@mixopia.com">support@mixopia.com</a>.
        </p>
      </NarrowContent>
      <Footer />
    </div>
  );
};

export default Home;
